<template>
  <div class="header-wrapper">
    <div class="container-center">
      <div class="header-box">
        <a class="logo" href="https://www.awcloud.com">
          <h1>AWcloud海云捷迅</h1>
        </a>
        <ul class="menu_list" id="awMenu">
          <li class="menu_item">
            产品
            <ul class="sub_list sub_list_large">
              <li>
                <p class="title">云基础设施</p>
                <a href="/awcloud">AWCloud云计算管理平台</a>
                <a href="/monitor">AWCloud监控云</a>
                <a href="/awcmp">AWCMP多云管理平台</a>
                <a href="/awcdp">AWCloud容器管理平台</a>
                <a href="/awstack">AWSTACK超融合一体机</a>
              </li>
              <li>
                <a class="title hover_title" href="/cloudservice">云服务 ></a>
              </li>
              <li>
                <p class="title">人工智能基础设施</p>
                <a href="/aiStack">AIStack人工智能管理平台</a>
              </li>
            </ul>
          </li>
          <li class="menu_item menu_item_solution">
            解决方案
            <ul class="sub_list sub_list_small">
              <li>
                <a href="/private_solutions" class="title hover_title"
                  >私有云解决方案</a
                >
              </li>
              <li>
                <a href="/ic_center" class="title hover_title"
                  >智算中心解决方案</a
                >
              </li>
            </ul>
          </li>
          <a class="menu_item" href="/cases">案例</a>
          <a class="menu_item" href="/custom_development">定制开发</a>
          <a class="menu_item" href="/consult">售前支持</a>
          <li class="menu_item" style="position: relative">
            关于我们
            <ul class="sub_list_single">
              <a href="/about/desc">企业简介</a>
              <a href="/about/contact">联系我们</a>
              <a href="/about/join">加入我们</a>
              <a href="/cooperate">合作伙伴</a>
              <a href="/news">企业新闻</a>
            </ul>
          </li>
        </ul>
        <div class="slogan"></div>
        <!-- 移动端 -->
        <div class="m-menu-icon" id="menuToggle">
          <img
            @click="toggleIcon"
            v-if="showIcon"
            class="menu-icon"
            src="@/assets/mobile/home_icon_mobile_menu@2x.png"
            alt=""
          />
          <img
            @click="toggleIcon"
            v-else
            class="close-icon"
            src="@/assets/mobile/home_icon_mobile_close@2x.png"
            alt=""
          />
        </div>

        <div class="m-nav" v-if="!showIcon">
          <div class="sidebar">
            <ul>
              <li :class="['m-nav-item', {active: menuTarget == 'product'}]" @click="chooseMenu('product')">产品</li>
              <li :class="['m-nav-item', {active: menuTarget == 'solve'}]" @click="chooseMenu('solve')">解决方案</li>
              <li><a href="/cases">案例</a></li>
              <li><a href="/custom_development">定制开发</a></li>
              <li><a href="/consult">售前支持</a></li>
              <li>
                <a href="https://ai.awcloud.com/home" target="_blank"
                  >算力租赁</a
                >
              </li>
              <li>
                <a href="https://fpgaba.com/" target="_blank">海云学堂</a>
              </li>
              <li :class="['m-nav-item', {active: menuTarget == 'aboutUs'}]" @click="chooseMenu('aboutUs')">关于我们</li>
            </ul>
          </div>
          <div class="content" id="product" v-if="menuTarget == 'product' && !showIcon">
            <div id="cloud">
              <p class="nav-title">云基础设施</p>
              <div class="sub-list">
                <a href="/awcloud">AWCloud云计算管理平台</a>
                <a href="/monitor">AWCloud监控云</a>
                <a href="/awcmp">AWCMP多云管理平台</a>
                <a href="/awcdp">AWCloud容器管理平台</a>
                <a href="/awstack">AWSTACK超融合一体机</a>
              </div>
            </div>
            <a class="single-nav" href="/cloudservice"> 云服务 > </a>
            <div id="ai">
              <p class="nav-title">人工智能基础设施</p>
              <div class="sub-list">
                <a href="/aiStack">AIStack人工智能管理平台</a>
              </div>
            </div>
          </div>
          <div class="content" id="solve" v-if="menuTarget == 'solve' && !showIcon">
            <a class="single-nav-first" href="/private_solutions">私有云解决方案</a>
            <a class="single-nav" href="/ic_center">智算中心解决方案</a>
          </div>
          <div class="content" id="aboutUs" v-if="menuTarget == 'aboutUs' && !showIcon">
            <div class="sub-list">
              <a href="/about/desc">企业简介</a>
              <a href="/about/contact">联系我们</a>
              <a href="/about/join">加入我们</a>
              <a href="/cooperate">合作伙伴</a>
              <a href="/news">企业新闻</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showIcon: true,
      menuTarget: 'product'
    };
  },
  methods: {
    toggleIcon() {
      this.showIcon = !this.showIcon;
    },
    chooseMenu(target) {
        this.menuTarget = target;
    },
  },
};
</script>
<style lang="less" scoped>
.header-wrapper {
  border-bottom: 1px solid #eaeaea;
  .container-center {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .header-box {
      display: flex;
      align-items: center;
      position: relative;
      height: 68px;
      background-color: #fffffffe;
      box-sizing: border-box;

      .logo {
        height: 40px;
        width: 163px;

        h1 {
          height: 40px;
          width: 163px;
          background: url("~@/assets/home/awcloud_logo.png") no-repeat 0 0;
          background-size: 100% 100%;
          text-indent: -9999px;
        }
      }

      .slogan {
        width: 200px;
        height: 68px;
        background: url("~@/assets/home/awcloud_slogan.png") 0 0 no-repeat;
        background-size: cover;
      }
      .m-menu-icon {
        display: none;
      }

      .m-nav {
        display: none;
      }

      .menu_list {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 70px;

        .menu_item {
          height: 68px;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #333;
          cursor: pointer;
          &:hover {
            cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 6px;
            color: #cc0100;

            .sub_list {
              display: flex !important;
              cursor: default;
            }

            .sub_list_single {
              display: flex !important;
              cursor: default;
            }
          }
        }
      }

      .sub_list {
        display: none;
        position: absolute;
        z-index: 10;
        padding: 24px 56px 0;
        top: 68px;
        left: 0;
        background: #ffffff;
        box-shadow: 0px 2px 20px #161c240d;
        color: #333;

        li {
          display: flex;
          flex-direction: column;
          width: 230px;
          margin-bottom: 12px;

          .title {
            font-size: 16px;
            color: #333333;
            height: 24px;
            line-height: 24px;
            padding-bottom: 8px;
            border-bottom: 1px solid #eaeaea;
            margin-bottom: 12px;
          }

          .hover_title {
            border: none;

            &:hover {
              color: #cc0100;
            }
          }

          span,
          a {
            color: #666666;
            font-size: 14px;
            margin-bottom: 16px;
            white-space: nowrap;

            &:hover {
              color: #cc0100;
              text-decoration: none;
            }
          }
        }
      }

      .menu_item_solution {
        position: relative;
      }

      .sub_list_large {
        width: 1200px;
        box-sizing: border-box;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        column-gap: 120px;

        li {
          width: auto;
        }
      }

      .sub_list_small {
        width: auto;
        box-sizing: border-box;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        // 文字居中，与「关于我们」下拉风格统一
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        padding: 16px 0;

        li {
          width: auto;
          margin-bottom: 12px;
          padding: 0 20px;

          .title {
            font-size: 14px;
            height: auto;
            line-height: 20px;
            padding-bottom: 0;
            margin-bottom: 0;
            white-space: nowrap;
          }

          a {
            margin-bottom: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .sub_list_single {
        display: none;
        z-index: 10;
        position: absolute;
        flex-direction: column;
        top: 100%;
        left: -20px;
        padding: 16px 0;
        background: #ffffff;
        box-shadow: 0 2px 20px #161c240d;
        font-size: 14px;
        a {
          width: 64px;
          text-align: center;
          color: #666;
          padding: 0 20px;
          margin-bottom: 12px;
          text-decoration: none;
          a {
            margin-bottom: 0;
          }

          &:hover {
            color: #cc0100;
          }
        }

        a:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

/* 移动端样式 */
@media (max-width: 768px) {
  /* 移动端特定的样式规则 */
  body {
    font-size: 16px;
  }

  .header {
    padding: 10px;
  }

  .header-wrapper {
    position: initial;
    // z-index: 9999;
    width: 100%;
    .container-center {
      width: 100%;
      /* 将宽度设置为100%，让其占据整个视口宽度 */
      padding: 0;
      /* 如果需要的话，可以添加一些内边距防止内容紧贴屏幕边缘 */
      box-sizing: border-box;
      /* 确保padding和border包含在元素的width内 */
      /* 头部样式 */
      .header-box {
        position: relative;
        padding: 0 16px;
        .logo {
          height: 38px;
          width: 108px;

          h1 {
            height: 38px;
            width: 108px;
            background: url("~@/assets/mobile/nav_AWCloudLogo@2x.png") no-repeat
              0 0;
            background-size: 100% 100%;
            text-indent: -9999px;
          }
        }

        .slogan {
          width: 148px;
          height: 50px;
          margin-left: 26px;
          background: url("~@/assets/mobile/nav_img_slogan.png@2x.png") 0 0
            no-repeat;
          background-size: cover;
        }

        .m-menu-icon {
          display: block;

          img {
            width: 24px;
            height: 24px;
          }

          margin-left: auto;
        }

        .menu_list {
          display: none;
        }

        .m-nav {
          display: flex;
          position: absolute;
          top: 69px;
          left: 0;
          z-index: 3;
          background-color: #fff;
          width: 100%;

          .sidebar {
            width: 136px; // 固定宽度
            background-color: #f8f9fa; // 背景色
            font-size: 16px;
            box-sizing: border-box;

            ul {
              li {
                height: 44px;
                line-height: 44px;
                padding-left: 20px;

                a {
                  text-decoration: none;
                }

                &:hover {
                  color: #cc0100;
                  background-color: #f4f8fc;
                }
              }

              .active {
                color: #cc0100;
                background-color: #f4f8fc;
              }
            }
          }

          .content {
            flex: 1; // 占满剩余空间
            padding: 8px 24px 33px; // 内边距
            background-color: #f4f8fc;
            width: calc(100% - 136px);

            .nav-title {
              font-size: 16px;
              color: #333;
              padding-bottom: 12px;
              margin-bottom: 8px;
              border-bottom: 1px solid #eaeaea;
            }

            .sub-list {
              display: flex;
              flex-direction: column;

              a {
                font-size: 14px;
                display: inline-block;
                color: #666;
                margin-bottom: 12px;
                text-decoration: none;
              }

              a:last-child {
                /* 选择最后一个a标签 */
                margin-bottom: 0;
              }
            }

            .single-nav {
              font-size: 16px;
              color: #333;
              display: inline-block;
              margin: 32px 0;
            }

            .single-nav-first {
              font-size: 16px;
              color: #333;
              display: inline-block;
            }

            .com-mgt {
              margin-top: 32px;
            }
          }
        }
      }
    }
  }
}
</style>